export default [
  { path: '/proformas/como-pagador', component: () => import('@/views/proforms/AsPayer') },
  { path: '/proformas/como-proveedor', component: () => import('@/views/proforms/AsProvider') }
]
